module.exports = __webpack_public_path__ + "img/kkb_mg10.bfd0fcb7.jpg";